import LayoutPaginaAcessos from '~componentes/LayoutPaginaAcessos.vue';
import AcessosPaginaPrincipal from './componentes/AcessosPaginaPrincipal.vue';

import AcessosListagem from './componentes/AcessosListagem.vue';
import AcessosDetalhamento from './componentes/AcessosDetalhamento.vue';
import AcessosInscricao from './componentes/AcessosInscricao.vue';
import AcessosImportacao from './componentes/AcessosImportacao.vue';

export default {
  path: '/acessos',
  component: LayoutPaginaAcessos,
  children: [
    {
      path: '',
      component: AcessosPaginaPrincipal,
      name: 'acessos',
    },
    {
      path: 'cursos',
      component: AcessosListagem,
      name: 'acessos.cursos',
    },
    {
      path: 'eventos',
      component: AcessosListagem,
      name: 'acessos.eventos',
    },
    {
      path: 'servicos',
      component: AcessosListagem,
      name: 'acessos.servicos',
    },
    {
      path: 'doacoes',
      component: AcessosListagem,
      name: 'acessos.doacoes',
    },
    {
      path: ':id/cursos',
      component: AcessosDetalhamento,
      name: 'acessos.cursos-detalhamento'
    },
    {
      path: ':id/eventos',
      component: AcessosDetalhamento,
      name: 'acessos.eventos-detalhamento'
    },
    {
      path: ':id/doacoes',
      component: AcessosDetalhamento,
      name: 'acessos.doacoes-detalhamento'
    },
    {
      path: ':id/cursos/inscricao',
      component: AcessosInscricao,
      name: 'acessos.cursos-inscricao'
    },
    {
      path: ':id/eventos/inscricao',
      component: AcessosInscricao,
      name: 'acessos.eventos-inscricao'
    },
    {
      path: ':id/doacoes/doar',
      component: AcessosInscricao,
      name: 'acessos.doacoes-doar'
    },
    {
      path: ':id/doacoes/:idInscricaoDiretaCript/doar',
      component: AcessosInscricao,
      name: 'acessos.doacoes-doar-recorrente'
    },
    {
      path: ':id/cursos/:idInscricaoDiretaCript/inscricao',
      component: AcessosInscricao,
      name: 'acessos.cursos-inscricao-linkdireto'
    },
    {
      path: ':id/eventos/:idInscricaoDiretaCript/inscricao',
      component: AcessosInscricao,
      name: 'acessos.eventos-inscricao-linkdireto'
    },
    {
      path: 'licitacoes',
      component: AcessosListagem,
      name: 'acessos.licitacoes',
    },
    {
      path: 'importacao',
      component: AcessosImportacao,
      name: 'acessos.importacao',
    },
  ]
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/acessos/rotas.js